import { render, staticRenderFns } from "./ModalChangePassword.vue?vue&type=template&id=bb21d634&"
import script from "./ModalChangePassword.vue?vue&type=script&lang=ts&"
export * from "./ModalChangePassword.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports